// extracted by mini-css-extract-plugin
export default {"workspace_subtitile":"LZ9P9w","workspaceSubtitile":"LZ9P9w"};